import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalPopUp from "@/Components/common/ModalPopUp";
import FilledLatestAnnouncementIcon from "@/Components/Icons/FilledLatestAnnouncementIcon";
import LatestAnnouncementIcon from "@/Components/Icons/LatestAnnouncementIcon";
import { RejectIcon } from "@/Components/Icons/RejectIcon";
import {
  toggleUpdateLoginAnnuouncementModal,
  updateClientNewAnnounmentData,
} from "@/reducers/clientAnnouncement";
import { formatLatestUpdateForAnnouncement } from "@/utilities/utils";

import { updateUser } from "../../../../reducers/clientprofile";

const UpdateLoginAnnouncementModal = () => {
  const { showUpdateLoginAnnuouncementModal } = useSelector(
    (state) => state.clientAnnouncement,
  );
  const { user } = useSelector((state) => state.clientProfile);
  const dispatch = useDispatch();

  useEffect(() => {
    user?.announcement_message != "" &&
      user?.announcement_message &&
      dispatch(toggleUpdateLoginAnnuouncementModal(true));
  }, []);

  const handleClose = () => {
    dispatch(toggleUpdateLoginAnnuouncementModal(false));
    dispatch(updateUser({ announcement_message: "" }));
    dispatch(
      updateClientNewAnnounmentData({
        announcement_id: user?.announcement_id,
        // user_id: user?.id
      }),
    );
  };

  return (
    <ModalPopUp
      show={showUpdateLoginAnnuouncementModal}
      panelClass="max-w-[770px] max-sm:max-w-[400px]"
    >
      <div className="flex flex-col gap-4">
        <div className="flex justify-between">
          <h3 className="text-[20px] font-semibold leading-[normal] text-black">
            Latest Announcements
          </h3>
          <button
            onClick={handleClose}
            className="text-red outline-none ring-0"
          >
            <RejectIcon />
          </button>
        </div>
        <div className="group flex w-fit items-center gap-3">
          <div className="rounded-lg bg-grey p-2 transition-all duration-300 group-hover:bg-primary">
            <LatestAnnouncementIcon
              cls={`h-[24px] w-[24px] text-primary  group-hover:hidden`}
            />
            <FilledLatestAnnouncementIcon
              cls={`pr-[3.5px] h-[24px] w-[24px] hidden group-hover:block !text-white`}
            />
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-Base text- line-clamp-1 font-semibold capitalize">
              {moment(user?.announcement_created_at).format("LL") ||
                "No Date Found"}
            </p>
            <p className="text-[14px] font-medium leading-[normal] text-txtColor">
              {user.announcement_id_ref_no || "ANN-10000"}
            </p>
          </div>
        </div>

        <div className="SubBranchescustom-scrollbar-ui max-h-[400px] w-full overflow-y-auto">
          <div
            className="ml-1 text-[16px] font-normal leading-[normal] text-black"
            dangerouslySetInnerHTML={{
              __html: formatLatestUpdateForAnnouncement(
                user.announcement_message ||
                  "Announcement Message not found. Please contact AppLocum team.",
              ),
            }}
          />
        </div>
      </div>
    </ModalPopUp>
  );
};

export default UpdateLoginAnnouncementModal;
